import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-gap: 5%;

  @media (max-width: 1360px) {
    grid-template: auto auto / 1fr;
    grid-gap: 20px;
    padding: 0;

    & > div {
      width: 100%;
    }
  }
`

export const Form = styled.div``

export const PreviewContainer = styled.div`
  max-width: 580px;
`

export const AditionalInfoContainer = styled.div`
  max-width: calc(80% - 6px);
  margin-bottom: 1.5rem;
  margin-top: 10px;

  @media (max-width: 1024px) {
    max-width: 100%;
  }
`
